import { IFormValues } from '../types';

const getInitialValues = (quickNotes: string): IFormValues => ({
  quickNotes,
});

export default getInitialValues;
